import styled from 'styled-components'
import EthIcon from 'assets/network-icons/eth-icon.svg?react'
import AVAXIcon from 'assets/network-icons/avax-icon.svg?react'
import BaseNetworkIcon from 'assets/network-icons/base-icon.svg?react'
import BscNetworkIcon from 'assets/network-icons/bsc-chain.svg?react'
import OpIcon from 'assets/network-icons/op-icon.svg?react'
import ARBIcon from 'assets/network-icons/arb-icon.svg?react'
import PolyIcon from 'assets/network-icons/polygon-icon.svg?react'
import Unsupported from 'assets/network-icons/unsupported-icon.svg?react'
import { Weight } from 'components'
import { css } from 'styled-components'
import { GLOBAL_COLORS } from 'theme'
import { Button } from '../button'
import Pending from 'assets/account-center/pending-dot.svg?react'

/**
 * Icons for displaying in the network
 */
export const EthereumIcon = styled(EthIcon)`
  width: 18px;
  height: 18px;
  margin-right: 5px;
`

export const BaseIcon = styled(BaseNetworkIcon)`
  width: 18px;
  height: 18px;
  margin-right: 5px;
`

export const BscIcon = styled(BscNetworkIcon)`
  width: 18px;
  height: 18px;
  margin-right: 5px;
`

export const AvalancheIcon = styled(AVAXIcon)`
  width: 18px;
  height: 18px;
  margin-right: 5px;
`

export const OptimismIcon = styled(OpIcon)`
  width: 18px;
  height: 18px;
  margin-right: 5px;
`

export const ArbitrumIcon = styled(ARBIcon)`
  width: 18px;
  height: 18px;
  margin-right: 5px;
`

export const PolygonIcon = styled(PolyIcon)`
  width: 18px;
  height: 18px;
  margin-right: 5px;
`

export const UnsupportedIcon = styled(Unsupported)`
  width: 18px;
  height: 18px;
  margin-right: 5px;
  fill: ${({ theme }) => theme.iconColor};
`

export const StyledWalletButton = styled(Button)<{ connected: boolean }>`
  width: 120px;
  height: 26px;
  border-radius: 16px;
  background: ${GLOBAL_COLORS.transparent};
  color: ${({ theme }) => theme.text1};
  ${({ buttonType }) =>
    buttonType === 'primary' &&
    css`
      width: 165px;
      height: 40px;
      background: ${GLOBAL_COLORS.ultramarine};
      border-radius: 20px;
      font-weight: ${Weight.Medium};
    `}
  &:hover {
    color: ${({ theme }) => theme.secondaryFontColor};
  }
`

export const ButtonWrapper = styled.div`
  position: relative;
`

export const MobilePending = styled(Pending)`
  position: absolute;
  top: 3px;
  right: 3px;
  width: 12px;
  height: 12px;
  border: 3px solid ${({ theme }) => theme.bg};
  border-radius: 50%;
  z-index: 1;
  background-color: ${({ theme }) => theme.bg};
`

export const PendingDot = styled(Pending)`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 12px;
  height: 12px;
  border: 3px solid ${({ theme }) => theme.bg};
  border-radius: 50%;
`
